// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2TuRs","title":"Info_title__bw2wa","links":"Info_links__2lumC","link":"Info_link__1k5NC","logo":"Info_logo__1BXnN"};